import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ApiService from 'cio/services/api';
import BillingService from 'cio/services/billing';
import { Plans } from 'cio/utils/billing/plans';

export default class DataPipelinePlansController extends Controller {
  @service api!: ApiService;
  @service billing!: BillingService;

  @tracked showCheckout = false;
  plans = [Plans.CdpStarter, Plans.CdpPremium];

  get nextUpgradePlanType() {
    if (this.billing.subscription?.plan?.slug === Plans.CdpStarter.slug) {
      return Plans.CdpPremium.planType;
    }
    return Plans.CdpStarter.planType;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'available-plans.data-pipelines': DataPipelinePlansController;
  }
}
